// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V7l7k","badges":"styles_badges__21xa4"};